import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * OAuth Callback Handler
 * 
 * This component handles the redirect from Google OAuth.
 * The PHP callback.php processes the OAuth code and stores session,
 * then redirects here to return to the app.
 */

function OAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we have a successful auth in URL
    const params = new URLSearchParams(window.location.search);
    
    if (params.get('success') === 'true') {
      // Redirect to portal
      navigate('/', { replace: true });
    } else if (params.get('error')) {
      // Show error
      navigate('/login', { 
        replace: true,
        state: { error: params.get('error') }
      });
    } else {
      // No params - just redirect to login
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      background: '#f8f9fa'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ 
          width: '40px', 
          height: '40px', 
          border: '3px solid #e5e7eb', 
          borderTopColor: '#C9A962',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }}></div>
        <p>Completing sign in...</p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default OAuthCallback;